// extracted by mini-css-extract-plugin
export default {"time":"FlatPricing_time__8I4yK","multiplyCheckboxLabel":"FlatPricing_multiplyCheckboxLabel__z58+n"};